module.exports = __webpack_public_path__ + "img/mastercard.9fe93bd.png";